<script>
import moment from "moment";
import 'moment/locale/es';
    export default {
        data(){
            return{
                message: "Hoy:",
                currentTime: null,
                hoy: moment(),
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight
            }
        },
        methods: {
            updateCurrentTime() {
                this.currentTime = moment().format("LTS");
            },
            diaespañol(){
                this.hoy=moment().format("dddd, MMMM YYYY");
            },
            handleResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            // console.log(this.windowWidth);
            // console.log(this.windowHeight);
        },
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            this.currentTime = moment().format("LTS");
            setInterval(() => this.updateCurrentTime(), 1 * 1000);
            this.hoy=moment().format("dddd, DD MMMM YYYY");
            this.handleResize();
        }

    }
</script>
<template>
    <div :class="windowWidth>576 ?'card overflow-hidden mb-3 bg-image':'card overflow-hidden mb-3'">
        <div class="card-body">
            <div class="row">
                <div :class="windowWidth>576 ?'col-md-6 text-left' :'col-md-6 text-center'">
                    <div class="row">
                        <div :class="windowWidth>576 ? 'col-md-3 text-right' : 'col-md-3 text-center pb-3'">
                            <img :src="user.sucursal.imagen_url" alt="" class="rounded-circle avatar-lg">
                        </div>
                        <div class="col-md-4">
                            <p :class="windowWidth>576 ?'pb-0 mb-0':'pb-2 mb-0'">Bienvenido a Inventario</p>
                            <label class="font-size-20">{{ user.sucursal.name }}</label>
                        </div>
                    </div>
                </div>
                <div :class="windowWidth>576 ? 'col-md-6 text-right':'col-md-6 text-center'">
                    <div class="row">
                        <div class="col-md-9">
                            <h2>{{hoy}}</h2>
                            <h1 v-text="currentTime"></h1>
                        </div>
                        <div class="col-md-3 mt-4">
                            <b-button block variant="teal" size="sm" href="/web/config/profile"><i class="bx bx-cog"></i> Configuración</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.bg-image{
    background-image: url("/images/layouts/Widget.png");
    height: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>